import { render } from "./IconWhistle.vue?vue&type=template&id=71db9a08&ts=true"
import script from "./IconWhistle.vue?vue&type=script&lang=ts"
export * from "./IconWhistle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__